<p-card [styleClass]="cardStyleClass()">
  <ng-content />
</p-card>
